module.exports = __webpack_public_path__ + "static/media/result-2.c381a547.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/result-2.png
// module id = 140
// module chunks = 0